export const theme = {
  primary: '#000000', 
  secondary: '#888888', 
  accent: '#ffffff', 
  background: '#050505', 
  cardBackground: 'rgba(255, 255, 255, 0.03)', 
  text: '#cccccc', 
  lightGray: '#ffffff', 
  darkGray: '#222222', 
  white: '#ffffff',
  gradient: 'linear-gradient(135deg, #050505 0%, #1a1a1a 100%)',
  shadow: '0 10px 30px -15px rgba(255, 255, 255, 0.05)',
  glassShadow: '0 8px 32px 0 rgba(255, 255, 255, 0.03)',
  glassBorder: '1px solid rgba(255, 255, 255, 0.08)',
  transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
  borderRadius: '16px',
  navHeight: '100px',
  navScrollHeight: '70px',
  fontPrimary: "'Inter', 'Calibre', -apple-system, system-ui, sans-serif",
  fontMono: "'Fira Code', 'Fira Mono', monospace",

  // Breakpoints
  bp: {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1440px',
    desktop: '2560px'
  }
};